import { Link } from "react-router-dom";
import styles from "./Widgets.module.css";
import { formatMNOK } from "../../format";
import { useCachedResource } from "../../lib/swrCache";
import { useFitCount } from "../../lib/useFitCount";

type KalkyleRad = {
  projectId: number;
  projectName: string;
  navn: string | null;
  versjonNr: number | null;
  status: string | null;
  sistEndret: string;
  resultat: number | null;
};

async function hentKalkyler(): Promise<KalkyleRad[]> {
  const r = await fetch("/api/kalkyler");
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const d = (await r.json()) as { kalkyler: KalkyleRad[] };
  return d.kalkyler ?? [];
}

export function SisteKalkyler() {
  const { data: rader, feil } = useCachedResource("kalkyler", hentKalkyler, { persist: true });
  const [fitRef, n] = useFitCount(58);

  if (feil && !rader) return <p className={styles.muted}>Kunne ikke laste kalkyler.</p>;
  if (!rader) return <p className={styles.muted}>Laster…</p>;
  if (!rader.length) return <p className={styles.muted}>Ingen kalkyler ennå.</p>;

  const sortert = [...rader].sort(
    (a, b) => Date.parse(b.sistEndret) - Date.parse(a.sistEndret)
  );

  return (
    <div ref={fitRef} className={styles.fyll}>
      <div className={styles.liste}>
        {sortert.slice(0, n).map((k) => (
          <Link key={k.projectId} to={`/kalkyle?prosjekt=${k.projectId}`} className={styles.rad}>
            <span className={styles.radKol}>
              <span className={styles.radTittel}>{k.navn ?? k.projectName}</span>
              <span className={styles.radMeta}>
                {k.versjonNr != null ? `v${k.versjonNr}` : "—"}
                {k.status ? ` · ${k.status}` : ""}
              </span>
            </span>
            <span className={styles.radVerdi}>
              {k.resultat != null ? formatMNOK(k.resultat) : "—"}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
